// assets/ce-product.js — atualiza preço extra (parcelas/desconto) ao trocar variante. (Guia de tamanhos: assets/ce-size-guide.js)
(function () {
  const swap = (html, id) => {
    const src = html.getElementById(id), dst = document.getElementById(id);
    if (src && dst) dst.replaceWith(src);
  };
  document.addEventListener('change', (e) => {
    const picker = e.target.closest('variant-radios, variant-selects');
    if (!picker) return;
    const sectionId = picker.dataset.section;
    setTimeout(() => {
      const variant = new URL(location.href).searchParams.get('variant');
      if (!variant || !sectionId) return;
      fetch(`${location.pathname}?variant=${variant}&section_id=${sectionId}`)
        .then((r) => r.text())
        .then((txt) => {
          const html = new DOMParser().parseFromString(txt, 'text/html');
          swap(html, `ce-price-extras-${sectionId}`);
        })
        .catch((err) => console.warn('ce-product: falha ao atualizar extras da variante', err));
    }, 400);
  });
})();
